import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_HELP_CARDS_GET_LIST,
} from 'api/actionTypes';

export default async function getList({ state, apiClient }, { screenId, partnerSignupType }) {
  typeCheck('screenId::NonEmptyString', screenId);

  const helpCardStatePath = [
    'helpCards',
    'list',
    [screenId, partnerSignupType].join('-'),
  ];

  if (state.get(helpCardStatePath)) {
    return state.get(helpCardStatePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_HELP_CARDS_GET_LIST,
    state: state,
    payload: {
      screenId: screenId,
      partnerSignupType: partnerSignupType,
    },
    onSuccess(helpCards) {
      if (helpCards) {
        state.set(helpCardStatePath, helpCards);
      }
      return helpCards;
    },
  });
}
